import EditEvent from './EditEventContainer';
export default EditEvent;
